import { IMicrofrontendsAPI } from 'shared/types/applicationContext';

interface IViewData {
  headingType: string | undefined;
}

export interface ICallAuthenticationPopupParameters {
  viewData?: IViewData;
  source?: string;
}

export function callAuthenticationPopup(
  microfrontendsAPI: IMicrofrontendsAPI | undefined,
  parameters?: ICallAuthenticationPopupParameters,
) {
  void microfrontendsAPI?.header.openAuthModal({
    autoRefresh: false,
    alert: null,
    useDefaultView: false,
    viewData: parameters?.viewData ?? null,
    source: parameters?.source ?? null,
  });
}
